import React  from 'react';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import ButtonCustom from "./ButtonCustom";
import { yellowButton } from "src/shared/styles/buttonStyles";

const SearchHoursSiteOficial = (props) => {

    return (
        <ButtonCustom
            {...props}
            style={{ ...yellowButton, height: '50px', marginTop: '20px' }}
            text="Agendar Hora"
            icon={<TouchAppIcon />}
        ></ButtonCustom>

    )
}

export default SearchHoursSiteOficial
